module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/badanie-techniczne-white-36px-9b29400b.png";